<template>
  <div>
    <div class="notice-top">
      <h2>
        <span>公  告</span>
        <em @click="handleClose"></em>
      </h2>
    </div>
    <div class="notice-list">
      <ul>
        <li v-for="t in noticeList"  :key="t.id">
          <h3>{{t.title}}</h3>
          <div v-html="t.content"></div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: "notice",
    data () {
      return {
        noticeList:[]
      }
    },
    created(){
      // this.getNotice('10060182236','SM-N9600','1');
    },
    methods: {
      // applyNo 应用编号
      // phoneModel机型
      // popnode 1进入游戏 2退出游戏
      getNotice(applyno,phoneModel,popnode){
        let that = this;
        this.$ajax({
          url:"coupon-market/notice/getNoticeShow",
          async:false,
          data:{applyno,phoneModel,popnode},
          token:window.sessionStorage.getItem('token'),
          success:function(response){
            if (response.code== 0) {
              that.noticeList=response.data;
            }else{
              that.$message.error(response.message);
            }
          },
          error:function(){
            that.$message.error("请求失败");
          }
        })
      },
      handleClose(){
        notice_android.noticeClose();
      }
    },
    mounted () {
      window.InitNotice = this.getNotice;
    },
  }
</script>

<style scoped>
  @import "../../static/css/notice.css"
</style>



// WEBPACK FOOTER //
// src/components/notice_view.vue